import { RcFile } from 'antd/es/upload';
import { ReactComponent as RateFace1On } from '@assets/images/app/icon-rate-face-1-on.svg';
import { ReactComponent as RateFace2On } from '@assets/images/app/icon-rate-face-2-on.svg';
import { ReactComponent as RateFace3On } from '@assets/images/app/icon-rate-face-3-on.svg';
import { ReactComponent as RateFace4On } from '@assets/images/app/icon-rate-face-4-on.svg';
import { ReactComponent as RateFace5On } from '@assets/images/app/icon-rate-face-5-on.svg';
import { Roles } from '@consts/role';
import { UserProfile } from './auth';
import { PagenatedResponse } from './common';
import PaymentStatement from './paymentStatement';
import { Product } from './product';

export const REVIEW_FACE_VALUES: {
  [key: string]: { Icon: React.ComponentType<React.SVGProps<SVGSVGElement>>; label: string };
} = {
  '1': {
    Icon: RateFace1On,
    label: '기대한 만큼은 아닌 것 같아요',
  },
  '2': {
    Icon: RateFace2On,
    label: '집중하기가 어려웠어요',
  },
  '3': {
    Icon: RateFace3On,
    label: '좋은 경험이었어요',
  },
  '4': {
    Icon: RateFace4On,
    label: '만족! 너무 즐거웠어요!',
  },
  '5': {
    Icon: RateFace5On,
    label: '최고! 다음에 또 하고싶어요!',
  },
};

export enum UserContentStatus {
  OPEN = 'open', // 게시
  PENDING = 'pending', // 대기
  SUGGESTION = 'suggestion', // 제안
  HIDDEN = 'hidden', // 숨김
  RESERVED = 'reserved', // 예약
  END = 'end', // 예약 종료
  DELIST = 'delist', // 삭제대기
}

export interface ProductReview extends UserContent {
  publisherInfo?: {
    childrenAgeText?: string;
    addressText?: string;
  };
}

export interface UserContent {
  _id: string;
  board: string; // review, curation, suggestion
  category: string; // lounge curation categories
  type: string; // post, instagram, twitter, ad
  publisherId: string;
  editorId?: string;
  rootId?: string;
  paymentStatementId?: string;
  product?: Partial<Product>;
  text: string;
  description?: string;
  title?: string;
  originText: string;
  images?: string[];
  rates?: UserContentRate;
  status: UserContentStatus;
  publisher?: {
    name?: string;
    nickname?: string;
    message?: string;
    imageUrl?: string;
    age?: string;
    location?: string;
    profile?: UserProfile;
    roles?: Roles[];
    categorySubList?: string[];
  };
  editor?: { name?: string };
  marketingAgreed?: boolean;
  paymentStatement?: PaymentStatement;
  bestDate?: Date;
  bestPointGrantedAt?: Date;
  publishedAt?: Date;
  createdAt: Date;
  updatedAt: Date;
  adminStatusChangedAt?: Date;
}

export interface UserContentRate {
  rate1: number;
  rate2: number;
  rate3: number;
  rate4: number;
  rate5: number;
}

export interface UserContentEditData {
  status: UserContentStatus;
  rate1?: number; // 친화력
  rate2?: number; // 전문성
  rate3?: number; // 준비성
  rate4?: number; // 시간준수
  rate5?: number; // 아이 만족도
  text: string;
  originText: string;
  images?: string[];
  imagesTemp?: string[];
  files?: { [key: string]: RcFile };
  type: string;
  category?: string;
  board: string;
  title?: string;
  description?: string;
  marketingAgreed?: boolean;
  policyAgreed?: boolean;
  product?: Partial<Product>;
  startDate?: Date;
  endDate?: Date;
}

export interface CreateUserContentBody extends UserContentEditData {
  productId?: string;
  paymentStatementId?: string;
}

export enum UserContentRateType {
  SOCIABILITY = '친화력',
  PROFESSIONALISM = '전문성',
  READINESS = '준비성',
  PUNCTUALITY = '시간준수',
}

export interface Children {
  name: string;
  birthday: string;
  gender: string;
}

export interface UserContentContainer extends PagenatedResponse<UserContent> {
  rateSummary?: { avg: number; rate1: number; rate2: number; rate3: number; rate4: number; rate5: number };
}

export interface UrlPreviewData {
  success: boolean;
  ogTitle: string;
  ogUrl: string;
  ogDescription: string;
  twitterCard: string;
  twitterUrl: string;
  twitterDescription: string;
  ogImage: OgImage[];
  twitterImage: TwitterImage[];
  ogLocale: string;
  favicon: string;
  charset: string;
}

export interface OgImage {
  url: string;
  type: string;
}

export interface TwitterImage {
  url: string;
}
